import { ReactElement } from 'react';
import AppLayout from '../layouts/AppLayout';
import React from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import ProductSlider from '../components/shop/ProductSlider';
import styled from 'styled-components';

const ShopContainer = styled.div`
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
`;

const Shop = (): ReactElement => {
    const paypalClientId = process.env.REACT_APP_FORGING_BRAINS_PAYPAL_CLIENT_ID || 'test';
    const isValidClientId = Boolean(paypalClientId && paypalClientId !== 'test' && paypalClientId.length > 10);

    return (
        <AppLayout>
            {isValidClientId ? (
                <PayPalScriptProvider
                    options={{ clientId: paypalClientId, currency: 'USD', components: 'buttons', intent: 'capture' }}
                >
                    <ShopContainer>
                        <ProductSlider />
                    </ShopContainer>
                </PayPalScriptProvider>
            ) : (
                <ShopContainer>
                    <div
                        style={{
                            border: '1px solid rgba(255,255,255,0.2)',
                            background: 'rgba(0,0,0,0.3)',
                            padding: '16px',
                            borderRadius: 8
                        }}
                    >
                        <h2 style={{ marginTop: 0 }}>Shop temporarily unavailable</h2>
                        <p style={{ marginBottom: 0 }}>
                            Checkout is currently disabled. Please try again later or contact us if you need assistance.
                        </p>
                    </div>
                </ShopContainer>
            )}
        </AppLayout>
    );
};

export default Shop;
